import { DateTimeStr, forceTz } from '@mi-front/core';
import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import moment from 'moment-timezone';
import { SingleDatePickerShape } from 'react-dates';
import 'react-dates/initialize';
import { InputProps } from '../../base';
import { DateField } from './DateInput';
import { TimeField } from './TimeInput';

type Props = Omit<InputProps, 'onChange' | 'css'> & {
  isOutsideRange?: SingleDatePickerShape['isOutsideRange'];
  value?: null | string | DateTimeStr;
  onChange?: (datetime: null | DateTimeStr) => void;
  size?: 'sm';
  showIcon?: boolean;
  tz: string;
  dateLabel: string;
  timeLabel: string;
  max?: DateTimeStr;
  onlyPast?: boolean;
  withSeconds?: boolean;
};

export function DateTimeField(props: Props & { name: string }) {
  const { name, dateLabel, timeLabel, tz, max: givenMax, onlyPast, withSeconds, ...rest } = props;

  let max = givenMax as string;

  if (!max && onlyPast !== false) {
    max = moment(new Date()).format('YYYY-MM-DD');
  }

  return (
    <Field name={name} {...rest}>
      {(fp: FieldProps) => {
        const currentValue = fp.field.value;

        const displayDate = moment(currentValue).tz(tz).format('YYYY-MM-DD');
        const displayTime = moment(currentValue)
          .tz(tz)
          .format(withSeconds ? 'HH:mm:ss' : 'HH:mm');

        return (
          <div className="d-flex" style={rest.style}>
            <div className="mr-3" style={{ width: '60%' }}>
              <DateField
                name={`__${name}_date`}
                label={dateLabel}
                value={displayDate}
                max={max}
                isOutsideRange={(date) => moment(date) > moment()}
                onChange={(value) => {
                  const time = moment(currentValue).tz(tz).format('HH:mm:ss');
                  const date = forceTz(`${value} ${time}` as any, tz);

                  fp.form.setFieldValue(name, moment(date).toISOString());
                }}
              />
            </div>
            <div style={{ width: '40%' }}>
              <TimeField
                name={`__${name}_time`}
                label={timeLabel}
                value={displayTime}
                onChange={(event) => {
                  const [hour, minutes, seconds] = event.currentTarget.value.split(':');

                  const value = moment(currentValue)
                    .tz(tz)
                    .hour(Number(hour))
                    .minutes(Number(minutes))
                    .seconds(withSeconds ? Number(seconds) : 0)
                    .milliseconds(0);

                  fp.form.setFieldValue(name, value.toISOString());
                }}
                step={withSeconds ? 1 : undefined}
              />
            </div>
          </div>
        );
      }}
    </Field>
  );
}
